"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.restore = restore;
var _events = require("../../types/events");
var _view = require("../../types/view");
var _authentication = require("../../types/authentication");
var _sentEmail = require("../../types/sentEmail");
var _action_types = require("../../constants/action_types");
var _remind = require("../../api/remind");
var _view2 = require("../view");
var _tracking = require("../../utils/tracking");
function restore(_ref) {
  let {
    email,
    source,
    nextView
  } = _ref;
  return (dispatch, _getState, context) => {
    dispatch({
      status: _authentication.ERestoreStatus.Loading,
      type: _action_types.AUTHENTICATION_RESTORE_TYPE
    });
    return (0, _remind.remind)(context.httpApi, {
      email
    }).then(response => {
      if (response.statusCode === 204) {
        dispatch({
          status: _authentication.ERestoreStatus.Succeed,
          type: _action_types.AUTHENTICATION_RESTORE_TYPE
        });
        (0, _tracking.trackForgotPasswordSubmitSuccess)(source);
        dispatch((0, _view2.changeView)(_view.EActiveView.EmailSent, {
          type: _sentEmail.ESentEmailType.Restore,
          email,
          nextView
        }));
        context.emitter.emit(_events.EEventType.RestoreSucceed, {
          email
        });
        return;
      }
      dispatch({
        status: _authentication.ERestoreStatus.Failed,
        type: _action_types.AUTHENTICATION_RESTORE_TYPE,
        error: response.response.message
      });
    }).catch(error => {
      context.logger.error(error, {
        domain: 'auth-widget.api.restore'
      });
      dispatch({
        status: _authentication.ERestoreStatus.Failed,
        type: _action_types.AUTHENTICATION_RESTORE_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}